module.exports = __webpack_public_path__ + "static/media/private_views.3f00be51.svg";